import React, { useState } from "react"
import PropTypes from "prop-types"
import PropTypesCustom from "src/helpers/propTypesCustom"
import groupBy from "ramda/es/groupBy"
import compose from "ramda/es/compose"
import sortBy from "ramda/es/sortBy"
import prop from "ramda/es/prop"
import path from "ramda/es/path"
import { Box } from "@infotech/uikit-grid"
import { Caption, Hint } from "@infotech/uikit-text"
import { DropdownDownIcon, DropdownUpIcon, OkIcon } from "@infotech/uikit-icons"
import DeletedIcon from "src/icons/deleted.svg"
import styles from "./styles.css"

const Resource = ({ name, label, button, isDeleted }) => (
  <Box
    className={styles.Resource}
    loose
    pl="2md"
    pr="2md"
    pt="1md"
    pb="1md"
    flex
  >
    <Box loose flex shrink={0} pr="3md" align="center">
      {/* TODO вставить передачу иконки через проп по мере необходимости */}
      {isDeleted ? (
        <DeletedIcon className={styles.DeletedIcon} />
      ) : (
        <OkIcon color="#007dfa" />
      )}
    </Box>
    <Box
      loose
      grow={1}
      flex
      column
      justify={typeof label === `string` ? `space-between` : `center`}
      pr="2md"
    >
      <Caption style={{ color: isDeleted ? `#7f7f7f` : `#565656` }}>
        {name}
      </Caption>
      {typeof label === `string` && (
        <Hint className={styles.ResourceHint}>{label}</Hint>
      )}
    </Box>
    <Box
      className={styles.ResourceButtons}
      flex
      align="center"
      loose
      shrink={0}
    >
      {button}
    </Box>
  </Box>
)

Resource.propTypes = {
  name: PropTypes.string.isRequired,
  button: PropTypes.node.isRequired,
  label: PropTypes.string,
  isDeleted: PropTypes.bool.isRequired,
}

Resource.defaultProps = {
  label: null,
}

const Group = ({ caption, children }) => {
  // Использую внутреннее состояние для простоты
  // Если будет нужно, можно вынести вовне
  const [isOpen, setOpen] = useState(true)

  return (
    <Box loose>
      <Box
        style={{ cursor: `pointer` }}
        loose
        flex
        onClick={() => setOpen(isOpen => !isOpen)}
      >
        <Box loose grow={1} pl="2md">
          <Caption style={{ color: `#7f7f7f` }}>{caption}</Caption>
        </Box>
        <Box loose flex align="center" pr="2md">
          {isOpen ? (
            <DropdownUpIcon color="#8d8d8d" />
          ) : (
            <DropdownDownIcon color="#8d8d8d" />
          )}
        </Box>
      </Box>
      {isOpen && (
        <Box pt="1md" pb="1md">
          {children}
        </Box>
      )}
    </Box>
  )
}

Group.propTypes = {
  caption: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

const groupById = groupBy(prop(`resourceTypeId`))
const sortByName = sortBy(path([1, 0, `resourceTypeName`]))

const transformResources = compose(sortByName, Object.entries, groupById)

const GroupedResources = ({ resources, Button, onButtonClick, isDisabled }) => (
  <Box loose>
    {transformResources(resources).map(([typeId, resources]) => (
      <Group key={typeId} caption={resources[0].resourceTypeName}>
        {resources.map(one => (
          <Box loose column>
            <Resource
              key={one.uuid}
              button={
                isDisabled ? null : (
                  <Button onClick={() => onButtonClick(one)} />
                )
              }
              name={one.name}
              label={one.label}
              isDeleted={Boolean(one.deleteDate)}
            />
          </Box>
        ))}
      </Group>
    ))}
  </Box>
)

GroupedResources.propTypes = {
  resources: PropTypes.arrayOf(
    PropTypes.shape({
      resourceTypeId: PropTypes.number.isRequired,
      resourceTypeName: PropTypes.string.isRequired,
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      deleteDate: PropTypes.string,
    }),
  ).isRequired,
  isDisabled: PropTypes.bool.isRequired,
  Button: PropTypesCustom.component.isRequired,
  onButtonClick: PropTypes.func.isRequired,
}

export default GroupedResources
